import { FormField, FormItem, FormLabel, FormControl, FormDescription } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { UseFormReturn } from "react-hook-form";
import { PatchPolicyFormValues } from "../../schema";
import { Badge } from "@/components/ui/badge";

interface AdvancedTabProps {
  form: UseFormReturn<PatchPolicyFormValues>;
}

export function AdvancedTab({ form }: AdvancedTabProps) {
  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <h3 className="text-lg font-semibold">Rapid Security Response (RSR)</h3>
          <Badge variant="outline" className="text-xs">macOS 13+</Badge>
        </div>
        <p className="text-sm text-muted-foreground mb-6">
          Configure settings for Apple's Rapid Security Response updates
        </p>
      </div>
      
      <div className="space-y-4">
        <FormField
          control={form.control}
          name="enable_rsr_installation"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
              <div className="space-y-0.5">
                <FormLabel className="text-base">Enable RSR Installation</FormLabel>
                <FormDescription>
                  Allow installation of Rapid Security Response updates
                </FormDescription>
              </div>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="enable_rsr_rollback"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
              <div className="space-y-0.5">
                <FormLabel className="text-base">Enable RSR Rollback</FormLabel>
                <FormDescription>
                  Allow rollback of RSR updates if issues occur
                </FormDescription>
              </div>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>

      <div className="rounded-lg bg-muted/50 p-4 mt-6">
        <p className="text-sm text-muted-foreground">
          <strong className="text-foreground">About RSR:</strong> Rapid Security Response updates are lightweight security patches that can be installed without a full system update. They provide quick fixes for critical security issues on macOS 13 and later.
        </p>
      </div>
    </div>
  );
}
